// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ef-a";
export var fulfillmentFormRail = "_ef-9";
export var headerTitleRow = "_ef-c";
export var orderDetailsWrapper = "_ef-7";
export var orderLinkTrigger = "_ef-2";
export var paymentInformationGrid = "_ef-h";
export var paymentSummaryColumn = "_ef-i";
export var shipmentContainer = "_ef-b";
export var shipmentDetailsMainPane = "_ef-8";
export var shipmentNavigationCard = "_ef-5";
export var shipmentNavigationRail = "_ef-3";
export var shipmentNavigationRailHeader = "_ef-4";
export var shipmentSummaryFact = "_ef-e";
export var shipmentSummaryGrid = "_ef-d";
export var shipmentSummaryMetadataRow = "_ef-f";
export var shipmentSummaryTags = "_ef-g";
export var shipmentWorkspace = "_ef-0";
export var shipmentWorkspaceContent = "_ef-6";
export var shipmentWorkspaceHeader = "_ef-1";